import React, { Component } from "react";
import "./MCAEvaluation.css";
import Cookie from 'js-cookie';
import {
    message, ConfigProvider, Divider,
    Table, Empty, Spin,
    Modal, Button, Form, Slider,
    Radio, Steps, Row, Col

} from 'antd';
import { Link } from "react-router-dom";
// import { cpus } from "os";
import AHP from '../ahp'

//create AHP modal
const AHPForm = Form.create({ name: 'form_in_modal' })(

    // eslint-disable-next-line
    class extends Component {
        render() {

            const {
                visible, onCancel, onCreate, form, projectAlternatives, criteria, ahpNext, ahpPrevious, ahpstep, ahpData
            } = this.props; //read all the property send from criteria
            const marks = {
                '-8': '9',
                '-7': '8',
                '-6': '7',
                '-5': '6',
                '-4': '5',
                '-3': '4',
                '-2': '3',
                '-1': '2',
                '-0': '1',
                '1': '2',
                '2': '3',
                '3': '4',
                '4': '5',
                '5': '6',
                '6': '7',
                '7': '8',
                '8': '9'
            };
            var evaluationCriteria = []
            criteria.forEach(obj => {
                if (obj.subCriteria && obj.subCriteria.length !== 0) {
                    if (obj.subCriteria.length === 1) {
                        var nc = JSON.parse(JSON.stringify(obj.subCriteria[0]));
                        nc["criteriaName"] = nc.subCriteriaName
                        nc["criteriaWeight"] = nc.subCriteriaWeight
                        delete nc["subCriteriaName"];
                        delete nc["subCriteriaWeight"]
                        evaluationCriteria.push(nc)
                    }
                    else {
                        for (var s in obj.subCriteria) {
                            var mnc = JSON.parse(JSON.stringify(obj.subCriteria[s]))
                            mnc["criteriaName"] = mnc.subCriteriaName
                            mnc["criteriaWeight"] = mnc.subCriteriaWeight
                            delete mnc["subCriteriaName"];
                            delete mnc["subCriteriaWeight"];
                            evaluationCriteria.push(mnc)
                        }
                    }
                }
                else {
                    evaluationCriteria.push(obj)
                }
            })
            function formatter(value) {
                return `${Math.abs(value) + 1}`;
            }
            const { getFieldDecorator } = form; //can get the input value
            var children = [];
            //print all the criteria group of this MCA
            if (evaluationCriteria[ahpstep]) { //if criteria readed, push the current step of evaluation
                children.push(<h4 key={evaluationCriteria[ahpstep].criteriaName}><b>{evaluationCriteria[ahpstep].criteriaName}</b>
                    <div>&nbsp;</div>
                </h4>)
                for (var i = 0; i < projectAlternatives.length - 1; i++) {
                    for (var j = i + 1; j < projectAlternatives.length; j++) {
                        children.push(
                            <Row style={{ textAlign: "center" }} key={`${evaluationCriteria[ahpstep].criteriaName}W%m$e${projectAlternatives[i].alternativeName}W%m$e${projectAlternatives[j].alternativeName}`} type="flex" justify="space-around">
                                <Col span={4}>
                                    <p>{projectAlternatives[i].alternativeName}</p>
                                </Col>
                                <Col span={16}>
                                    <Form.Item  >
                                        {getFieldDecorator(`${evaluationCriteria[ahpstep].criteriaName}W%m$e${projectAlternatives[i].alternativeName}W%m$e${projectAlternatives[j].alternativeName}`, { initialValue: ahpData[ahpstep] ? ahpData[ahpstep][`${evaluationCriteria[ahpstep].criteriaName}W%m$e${projectAlternatives[i].alternativeName}W%m$e${projectAlternatives[j].alternativeName}`] : 0 })(
                                            <Slider marks={marks} included={false} tipFormatter={formatter} min={-8} max={8} step={1} />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={4}>
                                    <p>{projectAlternatives[j].alternativeName}</p>
                                </Col>
                            </Row>
                        );
                    }

                }
            }
            return (
                <Modal
                    visible={visible} //control the showing of modal
                    title="Evaluation elicitation"
                    onCancel={onCancel}
                    onOk={onCreate}
                    okButtonProps={{ disabled: ahpstep !== evaluationCriteria.length - 1 }}
                    width={800}
                    okText={"Finish"}
                >
                    <Form layout="vertical">
                        {children}
                    </Form>
                    <Row style={{ textAlign: "center" }} type="flex" justify="space-between" className="steps-action">
                        <Col span={8}><Button onClick={ahpPrevious} disabled={ahpstep === 0}>Previous</Button></Col>
                        <Col span={8} ><Button style={{ marginLeft: 8 }} onClick={ahpNext} disabled={ahpstep === evaluationCriteria.length - 1}
                        >Next</Button></Col>
                    </Row>
                </Modal>
            );
        }

    }
);


//create SMART modal
const SMARTForm = Form.create({ name: 'form_in_modal' })(

    // eslint-disable-next-line
    class extends Component {
        render() {
            // const FormItem = Form.Item;

            const {
                visible, onCancel, onCreate, form, projectAlternatives, criteria, smartNext, smartPrevious, smartstep, smartData
            } = this.props; //read all the property send from criteria
            var evaluationCriteria = []
            const marks = {
                '0': '0',
                '1': '1',
                '2': '2',
                '3': '3',
                '4': '4',
                '5': '5',
                '6': '6',
                '7': '7',
                '8': '8',
                '9': '9',
                '10': '10'
            };
            criteria.forEach(obj => {
                if (obj.subCriteria && obj.subCriteria.length !== 0) {
                    if (obj.subCriteria.length === 1) {
                        var nc = JSON.parse(JSON.stringify(obj.subCriteria[0]));
                        nc["criteriaName"] = nc.subCriteriaName
                        nc["criteriaWeight"] = nc.subCriteriaWeight
                        delete nc["subCriteriaName"];
                        delete nc["subCriteriaWeight"]
                        evaluationCriteria.push(nc)
                    }
                    else {
                        for (var s in obj.subCriteria) {
                            var mnc = JSON.parse(JSON.stringify(obj.subCriteria[s]))
                            mnc["criteriaName"] = mnc.subCriteriaName
                            mnc["criteriaWeight"] = mnc.subCriteriaWeight
                            delete mnc["subCriteriaName"];
                            delete mnc["subCriteriaWeight"];
                            evaluationCriteria.push(mnc)
                        }
                    }
                }
                else {
                    evaluationCriteria.push(obj)
                }
            })
            function formatter(value) {
                return `${Math.abs(value)}`;
            }
            const { getFieldDecorator } = form; //can get the input value
            var scaleChildren = [];
            var directChildren = [];
            var title = "Title"
            var evaChildren = []
            //print all the criteria group of this MCA
            if (evaluationCriteria[smartstep]) { //if criteria readed, push the current step of evaluation
                title = evaluationCriteria[smartstep].criteriaName
                evaChildren.push(
                    <Form.Item style={{ textAlign: "center" }} key={`${evaluationCriteria[smartstep].criteriaName}`}>
                        {getFieldDecorator(`${evaluationCriteria[smartstep].criteriaName}`, {
                            initialValue: smartData[smartstep] ? smartData[smartstep][`${evaluationCriteria[smartstep].criteriaName}`] : "Scale",
                        })(
                            <Radio.Group>
                                <Radio value="Scale">10-Scale</Radio>
                                {/* <Radio value="Direct">Direct rating</Radio> */}
                            </Radio.Group>
                        )}
                    </Form.Item>
                )
                for (var i = 0; i < projectAlternatives.length; i++) {
                    scaleChildren.push(
                        <Row style={{ textAlign: "center" }} key={`${evaluationCriteria[smartstep].criteriaName}W%m$e${projectAlternatives[i].alternativeName}W%m$eScale`} type="flex" justify="space-around">
                            <Col span={4}>
                                <p>{projectAlternatives[i].alternativeName}</p>
                            </Col>
                            <Col span={16}>
                                <Form.Item  >
                                    {getFieldDecorator(`${evaluationCriteria[smartstep].criteriaName}W%m$e${projectAlternatives[i].alternativeName}W%m$eScale`, {
                                        initialValue: smartData[smartstep] && smartData[smartstep][`${evaluationCriteria[smartstep].criteriaName}`] === 'Scale' ? smartData[smartstep][`${evaluationCriteria[smartstep].criteriaName}W%m$e${projectAlternatives[i].alternativeName}W%m$eScale`] : 5
                                    })(
                                        <Slider marks={marks} max={10} min={0} tipFormatter={formatter} included={false} />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={4}>
                            </Col>
                        </Row>
                    );
                }
                // for (var j = 0; j < projectAlternatives.length; j++) {
                //     directChildren.push(
                //         <Row style={{ textAlign: "center" }} key={`${evaluationCriteria[smartstep].criteriaName},${projectAlternatives[j].alternativeName},Direct`} type="flex" justify="space-between">
                //             <Col span={8}>
                //                 <p>{projectAlternatives[j].alternativeName}</p>
                //             </Col>
                //             <Col span={8}>
                //                 <FormItem style={{ margin: 0 }}>
                //                     {form.getFieldDecorator(`${evaluationCriteria[smartstep].criteriaName},${projectAlternatives[j].alternativeName},Direct`, {
                //                         rules: [{
                //                             required: true,
                //                             message: `Value is required.`,
                //                         }],
                //                         initialValue: smartData[smartstep] && smartData[smartstep][`${evaluationCriteria[smartstep].criteriaName}`] === 'Direct' ? smartData[smartstep][`${evaluationCriteria[smartstep].criteriaName},${projectAlternatives[j].alternativeName},Direct`] : 0,
                //                     })(
                //                         <InputNumber
                //                             min={0}
                //                         />
                //                     )}
                //                 </FormItem>
                //             </Col>
                //         </Row>
                //     );
                // }
            }
            return (
                <Modal
                    visible={visible} //control the showing of modal
                    title="Evaluation elicitation"
                    onCancel={onCancel}
                    onOk={onCreate}
                    okButtonProps={{ disabled: smartstep !== evaluationCriteria.length - 1 }}
                    width={800}
                    okText={"Finish"}
                >
                    <h4><b>{title}</b>
                        <div>&nbsp;</div>
                    </h4>
                    <Form layout="vertical">
                        {evaChildren}
                        {this.props.form.getFieldsValue()[title] === 'Direct' ? directChildren : scaleChildren}
                    </Form>
                    <Row style={{ textAlign: "center" }} type="flex" justify="space-between" className="steps-action">
                        <Col span={8}><Button onClick={smartPrevious} disabled={smartstep === 0}>Previous</Button></Col>
                        <Col span={8} ><Button style={{ marginLeft: 8 }} onClick={smartNext} disabled={smartstep === evaluationCriteria.length - 1}>Next</Button></Col>
                    </Row>
                </Modal>
            );
        }

    }
);


export default class MCAEvaluation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: Cookie.get("email"),

            // MCAid: "",
            ahpVisible: false, //for ahp criteria modal
            smartVisible: false, //for SMART modal
            loading: true, //the loading status default true
            project: {},
            ahpstep: 0,
            ahpData: [],
            smartstep: 0,
            smartData: [],
            criteria: [],
            projectAlternatives: [],
            column: [],
            data: [],
        };
    }

    onStepChange = current => {
        if (current === 0) {
            this.props.history.push(`/alternative/${this.props.match.params.projectid}`)
        }
        if (current === 1) {
            this.props.history.push(`/mcacriteria/${this.props.match.params.projectid}`)
        }
        if (current === 2) {
            this.props.history.push(`/mcaweight/${this.props.match.params.projectid}`)
        }
        if (current === 4) {
            this.props.history.push(`/mcaresult/${this.props.match.params.projectid}`)
        }
    }

    //show or cancel ahp modal
    showAHPModal = () => {
        this.setState({ ahpVisible: true });
    }

    handleAHPCancel = () => {
        this.setState({ ahpVisible: false });
        // this.setState({ ahpstep: 0 });

    }
    ahpNext = () => {
        const form = this.formRef.props.form;
        var a = this.state.ahpData
        form.validateFields((err, values) => {
            a[this.state.ahpstep] = values
        })
        var s = this.state.ahpstep + 1
        this.setState({
            ahpstep: s,
            ahpData: a
        });
    }
    ahpPrevious = () => {
        const form = this.formRef.props.form;
        var a = this.state.ahpData
        form.validateFields((err, values) => {
            a[this.state.ahpstep] = values
        })
        var s = this.state.ahpstep - 1
        this.setState({
            ahpstep: s,
            ahpData: a
        });
    }

    //show or cancel SMART modal
    showSMARTModal = () => {
        this.setState({ smartVisible: true });
    }

    handleSMARTCancel = () => {
        this.setState({ smartVisible: false });
        // this.setState({ ahpstep: 0 });

    }

    smartNext = () => {
        const form = this.SformRef.props.form;
        var a = this.state.smartData
        form.validateFields((err, values) => {
            a[this.state.smartstep] = values
        })
        var s = this.state.smartstep + 1
        this.setState({
            smartstep: s,
            smartData: a
        });
    }

    smartPrevious = () => {
        const form = this.SformRef.props.form;
        var a = this.state.smartData
        form.validateFields((err, values) => {
            a[this.state.smartstep] = values
        })
        var s = this.state.smartstep - 1
        this.setState({
            smartstep: s,
            smartData: a
        });
    }

    handleAHPEvaluation = () => {
        const form = this.formRef.props.form;
        var a = this.state.ahpData
        form.validateFields((err, values) => {
            a[this.state.ahpstep] = values
        })
        this.setState({
            ahpData: a
        });
        var evaluationResult = [] //the total evaluation result 
        a.forEach(values => { //for each evaluaion group
            var pairwiseRank = []
            for (var v in values) { //for each evaluation
                var match = v.split('W%m$e')
                var n = values[v]
                var c = match[0]
                if (n < 0) {
                    n = Math.abs(n) + 1 //convert to pairwise value
                }
                else {
                    n = 1 / (Math.abs(n) + 1)
                }
                match.push(n)
                pairwiseRank.push(match)
                match.shift()
            }
            const criteriaItem = [...new Set([].concat(...this.state.projectAlternatives.map(o => o.alternativeName)))]; //magic function for save unique array                  
            // const AHP = require('ahp');
            var ahpContext = new AHP();
            ahpContext.addItems(criteriaItem);
            ahpContext.addCriteria([c]);
            //rank criteria with rank scale
            ahpContext.rankCriteriaItem(c, pairwiseRank);
            let output = ahpContext.run();
            var evaluationItem = {}
            evaluationItem.criteriaName = c
            evaluationItem.result = output.rankedScoreMap
            evaluationResult.push(evaluationItem)
        }
        )
        fetch('/project/evaluateMAMCAAHPSMART', { //REST create project
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                uid: this.props.match.params.projectid,
                evaluationResult: evaluationResult,
                MCAid: this.state.MCAid,
                email: Cookie.get("email"),
            }),
        })
            .then(res => res.json())
            .then(json => {
                if (json.success) {
                    this.getProject();
                    message.success(json.message); //create successfully, show message
                    this.setState({
                        ahpVisible: false, //for ahp modal,
                        // ahpData: [], //comment so the values keep
                        ahpstep: 0,
                        // smartData: [],
                        smartstep: 0,
                    }); //make modal invisible
                    // form.resetFields(); //reset the form
                }
                else {
                    message.error(json.message); //create unsuccessful, show alert
                }
            });
    }

    handleSMARTEvaluation = () => {
        const form = this.SformRef.props.form;
        var a = this.state.smartData
        form.validateFields((err, values) => {
            a[this.state.smartstep] = values
        })
        this.setState({
            smartData: a
        });
        var evaluationResult = [] //the total evaluation result 
        a.forEach(values => {
            // var eva = ""
            var evaluationItem = {}
            //  var totalScore = 0
            //  var totalNumber = 0
            var evaResult = {}
            for (var v in values) { //loop the evaluation
                var match = v.split('W%m$e')
                // var n = values[v] //get the value of object
                if (match.length === 1) {//this is the evaluation type
                    // eva = n //the evaluation type
                    evaluationItem.criteriaName = match[0]
                }
                else { //this is evaluation
                    // if (match[2] === eva) { //this is what we need to calculate
                    //     totalScore += n //add the score
                    //     totalNumber++
                    // }
                }
            }
            for (var i in values) {
                var vmatch = i.split('W%m$e')
                var o = values[i] //get the value of object
                // if (vmatch.length !== 1 && eva === vmatch[2]) { //calculate the weight
                //     if (totalScore === 0) { //average
                //         evaResult[`${vmatch[1]}`] = 1 / totalNumber
                //     }
                //     else {
                //         evaResult[`${vmatch[1]}`] = o / totalScore
                //     }
                // }
                evaResult[`${vmatch[1]}`] = o/10
                evaluationItem.result = evaResult
            }
            evaluationResult.push(evaluationItem)
        })
        fetch('/project/evaluateMAMCAAHPSMART', { //REST create project
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                uid: this.props.match.params.projectid,
                evaluationResult: evaluationResult,
                email: Cookie.get('email'),
                MCAid: this.state.MCAid,
            }),
        })
            .then(res => res.json())
            .then(json => {
                if (json.success) {
                    this.getProject();
                    message.success(json.message); //create successfully, show message
                    this.setState({
                        smartVisible: false, //for ahp modal,
                        // smartData: [],
                        smartstep: 0,
                        // ahpData: [],
                        ahpstep: 0
                    }); //make modal invisible
                    // form.resetFields(); //reset the form
                }
                else {
                    message.error(json.message); //create unsuccessful, show alert
                }
            });
    }

    //get the projects
    getProject = () => {
        fetch(`/project/getProject/${this.props.match.params.projectid}/${Cookie.get("email")}/`, { //get the project id from link
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    if(json.project.projectActorGroup&&json.project.projectActorGroup[0]){
                    if(json.project.projectActorGroup&&json.project.projectActorGroup[0].actorCriteria.length!==0)
                    {
                    var column = []
                    var row = {}
                    row.title = 'Alternative name'
                    row.dataIndex = 'alternativeName'
                    row.key = 'alternativeName'
                    row.sorter = (a, b) => { if (a.alternativeName > b.alternativeName) { return -1; } if (a.alternativeName < b.alternativeName) { return 1; } return 0; }
                    column.push(row)
                    json.project.projectActorGroup[0].actorCriteria.forEach(obj => {
                        var crow = {}
                        if (obj.subCriteria && obj.subCriteria[0]) { //there is subcriteria
                            let cW = 0
                            obj.actors.forEach(aobj => {
                                if (aobj.actorEvaluator === Cookie.get("email")) { //find the evaluator
                                    cW = aobj.actorCriteriaWeight
                                    crow.title = obj.criteriaName + ` (` + (aobj.actorCriteriaWeight * 100).toFixed(0) + `%)`
                                }
                            })
                            var cChildren = []
                            obj.subCriteria.forEach(subObj => {
                                var subrow = {}
                                subObj.actors.forEach(saobj => {
                                    if (saobj.actorEvaluator === Cookie.get("email")) { //find the evaluator
                                        subrow.title = subObj.subCriteriaName + ` (` + ((saobj.actorSubCriteriaWeight * cW) * 100).toFixed(0) + `%)`
                                    }
                                })
                                subrow.dataIndex = subObj.subCriteriaName
                                subrow.key = subObj.subCriteriaName
                                subrow.sorter = (a, b) => { if (a[subObj.subCriteriaName] > b[subObj.subCriteriaName]) { return -1; } if (a[subObj.subCriteriaName] < b[subObj.subCriteriaName]) { return 1; } return 0; }
                                cChildren.push(subrow)
                            })
                            crow.children = cChildren
                        }
                        else { //no suubcriteria
                            obj.actors.forEach(aobj => {
                                if (aobj.actorEvaluator === Cookie.get("email")) { //find the evaluator
                                    crow.title = obj.criteriaName + ` (` + (aobj.actorCriteriaWeight * 100).toFixed(0) + `%)`
                                }
                            })
                            crow.dataIndex = obj.criteriaName
                            crow.key = obj.criteriaName
                            crow.sorter = (a, b) => { if (a[obj.criteriaName] > b[obj.criteriaName]) { return -1; } if (a[obj.criteriaName] < b[obj.criteriaName]) { return 1; } return 0; }
                        }
                        column.push(crow)
                    })
                    var erow = {}
                    erow.title = 'Evaluation score'
                    erow.dataIndex = 'alternativeScore'
                    erow.key = 'alternativeScore'
                    erow.sorter = (a, b) => { if (a.alternativeScore > b.alternativeScore) { return -1; } if (a.alternativeScore < b.alternativeScore) { return 1; } return 0; }
                    column.push(erow)

                    var data = []
                    json.project.projectAlternatives.forEach(alternative => {
                        var aData = {}
                        var finalResult = 0
                        aData.key = alternative._id
                        aData.alternativeName = alternative.alternativeName
                        json.project.projectActorGroup[0].actorCriteria.forEach(obj => {
                            if (obj.subCriteria && obj.subCriteria.length !== 0) { //there is sub-criterion
                                var pCriteriaWeight
                                obj.actors.forEach(Aobj => {
                                    if (Aobj.actorEvaluator === Cookie.get("email")) {
                                        pCriteriaWeight = Aobj.actorCriteriaWeight

                                    }
                                })
                                obj.subCriteria.forEach(subobj => {
                                    if (subobj.actors && subobj.actors.length !== 0) { //there is result
                                        subobj.actors.forEach(asubobj => {
                                            if (asubobj.actorEvaluator === Cookie.get("email")) { //find the evaluator
                                                asubobj.actorSubCriteriaResult.forEach(rasubobj => {
                                                    if (rasubobj.subCriteriaAlternativeName === alternative.alternativeName) {
                                                        aData[subobj.subCriteriaName] = rasubobj.subCriteriaAlternativeScore
                                                        finalResult = finalResult + pCriteriaWeight * rasubobj.subCriteriaAlternativeScore * asubobj.actorSubCriteriaWeight
                                                    }
                                                })
                                            }
                                        })
                                    }
                                })
                            }
                            else {
                                if (obj.actors && obj.actors.length !== 0) {
                                    obj.actors.forEach(aobj => {
                                        aobj.actorCriteriaResult.forEach(raobj => {
                                            if (raobj.criteriaAlternativeName === alternative.alternativeName) {
                                                aData[obj.criteriaName] = raobj.criteriaAlternativeScore
                                                finalResult = finalResult + raobj.criteriaAlternativeScore * aobj.actorCriteriaWeight
                                            }
                                        })
                                    })
                                }
                            }
                        })
                        aData.alternativeScore = finalResult.toFixed(3)
                        data.push(aData)
                    })
                    this.setState({
                        project: json.project,
                        projectName: json.project.projectName,
                        projectType: json.project.projectType,
                        projectAlternatives: json.project.projectAlternatives,
                        projectEvaluationType: json.project.projectEvaluationType,
                        criteria: json.project.projectActorGroup[0].actorCriteria,
                        MCAid: json.project.projectActorGroup[0]._id,
                        loading: false,
                        column: column,
                        data: data,
                    }) //save project data

                    }}
                    else
                    {
                        let url='/mcaweight/'+this.props.match.params.projectid
                        message.error('No actor or criteria')
                        this.props.history.push(url); 

                    }

                }
                else {
                    message.error(json.message)
                    this.props.history.push("/"); //redirect to homepage if the project not exist, shouldn't be a case
                }
            });
    }

    //save all the form data of create
    saveFormRef = (formRef) => {
        this.formRef = formRef;
    }

    saveSFormRef = (formRef) => {
        this.SformRef = formRef;
    }

    componentDidMount() {
        try {
            this.getProject() //after render immediately get alternative list
        } catch (e) {
            alert(e);
        }
    }

    render() {


        const Step = Steps.Step;
        //the step infomation
        const mcaSteps = [{
            title: 'Alternatives',
        }, {
            title: 'Criteria',
        }, {
            title: 'Weights',
        }, {
            title: 'Evaluation',
        }, {
            title: 'Result',
        }];

        return <div className="MCACriteria">
            <Spin size="large" tip="Loading..." spinning={this.state.loading}>
                <Row style={{ marginTop: "5vh" }} type="flex" justify="space-around">
                        <h3>{this.state.projectName}</h3>
                </Row>
                <Divider />
                <Steps style={{ width: "80%", margin: "auto" }} current={3} onChange={this.onStepChange}>
                    {mcaSteps.map(item => <Step key={item.title} title={item.title} />)}
                </Steps>
                <div className="steps-content"></div>
                {this.state.projectEvaluationType === "AHP" ?
                    <Button style={{ marginLeft: "0" }} type="primary" size="large" onClick={this.showAHPModal}>AHP Evaluation</Button> :
                    <Button style={{ marginLeft: "2vh" }} type="primary" size="large" onClick={this.showSMARTModal}>SMART Evaluation</Button>
                }
                {/* <Button style={{ marginLeft: "0" }} type="primary" size="large" onClick={this.showAHPModal}>AHP Evaluation</Button>
                <Button style={{ marginLeft: "2vh" }} type="primary" size="large" onClick={this.showSMARTModal}>SMART Evaluation</Button> */}
                <div>&nbsp;</div>
                <ConfigProvider renderEmpty={() => { return (<Empty />); }}>
                    <Table columns={this.state.column}
                        bordered
                        // rowKey={record => record._id} //unique key needed, so we use mongodb id
                        dataSource={this.state.data} //the data source is what we get after component mount
                    />
                </ConfigProvider>
                <Divider />
                {/* {this.state.project.projectEvaluated ? <div /> : <p>You have to evaluate to continue</p>} */}
                <div className="steps-action">
                    {/* disabled={!this.state.project.projectEvaluated} */}
                    <Button size="large" type="primary" >
                        <Link to={`/mcaresult/${this.props.match.params.projectid}`}>Result</Link></Button>
                    <Button size="large" style={{ marginLeft: 8 }}>
                        <Link to={`/mcaweight/${this.props.match.params.projectid}`}>Previous</Link></Button>
                </div>
            </Spin>
            <AHPForm
                wrappedComponentRef={this.saveFormRef}
                visible={this.state.ahpVisible}
                onCancel={this.handleAHPCancel}
                onCreate={this.handleAHPEvaluation}
                projectAlternatives={this.state.projectAlternatives} //send alternatives
                criteria={this.state.criteria}
                ahpstep={this.state.ahpstep}
                ahpNext={this.ahpNext}
                ahpPrevious={this.ahpPrevious}
                ahpData={this.state.ahpData}

            />
            <SMARTForm
                wrappedComponentRef={this.saveSFormRef}
                visible={this.state.smartVisible}
                onCancel={this.handleSMARTCancel}
                onCreate={this.handleSMARTEvaluation}
                projectAlternatives={this.state.projectAlternatives} //send alternatives
                criteria={this.state.criteria}
                smartstep={this.state.smartstep}
                smartNext={this.smartNext}
                smartPrevious={this.smartPrevious}
                smartData={this.state.smartData}

            />
        </div>;
    }
}